<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.3331 11.9129V13.7462L14.6665 14.5795"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.3331 1.9129V4.4129"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.5 6.3612V4.4129C17.5 3.9708 17.3243 3.5469 17.0118 3.2343C16.6993 2.9218 16.2754 2.7462 15.8333 2.7462H4.1667C3.7246 2.7462 3.3007 2.9218 2.9882 3.2343C2.6756 3.5469 2.5 3.9708 2.5 4.4129V16.0795C2.5 16.5215 2.6756 16.9455 2.9882 17.258C3.3007 17.5705 3.7246 17.7462 4.1667 17.7462H6.115"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.5 7.7462H7.3825"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M6.6669 1.9129V4.4129"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.3331 18.5798C16.0946 18.5798 18.3332 16.3413 18.3332 13.5799C18.3332 10.8185 16.0946 8.5799 13.3331 8.5799C10.5717 8.5799 8.3331 10.8185 8.3331 13.5799C8.3331 16.3413 10.5717 18.5798 13.3331 18.5798Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCalendarClock',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
